var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVouchers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_377_5343",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H21.5V17.4997H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_377_5343)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.452 17.4998H4.048C1.816 17.4998 0 15.7018 0 13.4928V10.9008C0 10.4868 0.336 10.1508 0.75 10.1508C1.537 10.1508 2.177 9.52276 2.177 8.75076C2.177 8.00076 1.563 7.43476 0.75 7.43476C0.551 7.43476 0.36 7.35576 0.22 7.21476C0.079 7.07476 0 6.88276 0 6.68476L0.001 4.00676C0.001 1.79776 1.817 -0.000244141 4.049 -0.000244141H17.451C19.683 -0.000244141 21.499 1.79776 21.499 4.00676L21.5 6.60076C21.5 6.79876 21.421 6.99076 21.28 7.13076C21.14 7.27176 20.949 7.35076 20.75 7.35076C19.963 7.35076 19.323 7.97876 19.323 8.75076C19.323 9.52276 19.963 10.1508 20.75 10.1508C21.164 10.1508 21.5 10.4868 21.5 10.9008V13.4928C21.5 15.7018 19.684 17.4998 17.452 17.4998",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5996 11.8252C13.1856 11.8252 12.8496 11.4892 12.8496 11.0752V6.25415C12.8496 5.84015 13.1856 5.50415 13.5996 5.50415C14.0136 5.50415 14.3496 5.84015 14.3496 6.25415V11.0752C14.3496 11.4892 14.0136 11.8252 13.5996 11.8252",
    fill: "#021239"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVouchers);
export default __webpack_public_path__ + "static/media/Vouchers.6a274071e632a0162280a65de19f99e1.svg";
export { ForwardRef as ReactComponent };